import { render, staticRenderFns } from "./arinvrevisionfrm.vue?vue&type=template&id=59515c11"
import script from "./arinvrevisionfrm.vue?vue&type=script&lang=js"
export * from "./arinvrevisionfrm.vue?vue&type=script&lang=js"
import style0 from "./arinvrevisionfrm.vue?vue&type=style&index=0&id=59515c11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports